var React = require('react');

function Rating (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"m12 5.467 1.566 3.212.555 1.14 1.244.183 3.5.515-2.534 2.5-.899.888.213 1.254.598 3.53-3.131-1.667L12 16.43l-1.112.592-3.131 1.666.598-3.53.212-1.253-.9-.888-2.532-2.5 3.5-.515 1.243-.182.556-1.141zM12 0 8.292 7.608 0 8.828l6 5.922-1.416 8.361L12 19.163l7.416 3.948L18 14.751l6-5.923-8.291-1.22z"}));
}

Rating.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Rating;

Rating.default = Rating;
